import { CSSObject } from '@chakra-ui/react';
import bgDesktop from '@/assets/betstride/images/onboarding/onboardingAside.png';
import bgMobile from '@/assets/betstride/images/onboarding/onboardingAsideMb.png';

export const WrapperAside: CSSObject = {
  bg: [`url(${bgMobile})`, null, `url(${bgDesktop}), #041C22`],
  bgSize: ['cover', null, 'contain'],
  bgRepeat: ['no-repeat', null, 'no-repeat'],
  display: 'flex',
  flexDir: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  px: [null, null, '10px'],
  borderBottom: ['3px', null, 'unset'],
  borderBottomColor: ['beta.500', null, 'unset'],
  h: ['50vw', '55vw', 'full'],
  borderLeftRadius: [null, null, '10px'],
  borderRightRadius: ['unset'],
  pt: ['4', null, '6'],
  flex: 1,
  a: {
    h: 40,
    img: {
      pos: 'absolute',
      maxW: ['58vw', '500px', '200px'],
      top: ['100px', '120px', '100px'],
      left: ['200px', '300px', '150px'],
      transform: 'translate(-50%, -50%)',
    },
  },
  fontFamily: 'accent',
};
